/**
 * Public dispensary catalog fetcher. Lifted from
 * `apps/customer-web/src/lib/fetch-public-dispensary-catalog.ts` so
 * customer-mobile can call the same endpoint without re-implementing.
 *
 * Endpoint is unauthenticated; `baseUrl` parameter handles the per-app
 * env layer (Vite for web, Expo for mobile). Pass `""` for same-origin
 * (web's Vite dev proxy mode).
 */
import { publicDispensaryCatalogUrl } from "./url-builders";
export async function fetchPublicDispensaryCatalog(baseUrl) {
    const url = publicDispensaryCatalogUrl(baseUrl);
    const res = await fetch(url);
    if (!res.ok) {
        throw new Error(`catalog_http_${res.status}`);
    }
    return (await res.json());
}
//# sourceMappingURL=dispensary-catalog.js.map